import { type Components, type Theme } from "@mui/material/styles";

export const muiSwitch: Components<Theme>["MuiSwitch"] = {
  defaultProps: {
    size: "small",
  },
};
